import instance from "../utils/network";
import { Cafe, PubTournament, PubType, ReservationResponse } from "./types";

export interface TournamentItmResponse {
  rank: number;
  prize: number;
  stack: number;
  subPrize: string;
  memberId: number;
  nickname: string;
  isSubPrize: boolean;
}
export interface TournamentUserResponse {
  rebuyCount: number;
  addonCount: number;
  memberId: number;
  nickname: string;
  isSitout: boolean;
}

export interface TournamentStateResponse {
  tournament: PubTournament;
  itm: TournamentItmResponse[];
  sitInUser: TournamentUserResponse[];
  sitOutUser: TournamentUserResponse[];
  pubName: string;
  pubType: PubType;
  reservation?: ReservationResponse;
}

export function getTournamentState(
  tournamentId: number
): Promise<TournamentStateResponse> {
  return instance.get(`/nest/tournament/state/${tournamentId}`);
}

export function cafeTournament(id: number): Promise<PubTournament[]> {
  return instance.get("/nest/tournament/pub-not-end/" + id);
}

export function cafeTournamentsStarted(
  cafeList: Cafe[]
): Promise<PubTournament[]> {
  const cafeIds = cafeList.map((cafe) => cafe.id);
  return instance.post("/nest/tournament/pubs", { cafeIds });
}
